import { lazy } from 'react';

const ServicesPage = lazy(() => import('../pages/Services.page'));
const ServicesDetailsPage = lazy(() => import('../pages/ServicesDetails.page'));

const ServicesRoutes = [
    {
        path: '/services',
        children: [
            { index: true, element: <ServicesPage />, layout: 'default', isAuthReq: true },
            {
                path: ':id',
                element: <ServicesDetailsPage />,
                layout: 'default',
                isAuthReq: true,
            }
        ],
        layout: 'default',
        isAuthReq: true,
    },

];

export { ServicesRoutes };
